/**
 * Admin Messages Filters Meta Hook
 *
 * Cached React Query hook for GET /api/admin/messages/filters/meta/ — the
 * choice lists the Messages filter bar renders from: statuses, origins,
 * origin_details actually present, recipient kinds, channels, email template
 * variants, automations (id/name/slug) and the bucket names. Mostly
 * code-defined, so it is kept fresh for a long time; the Automations hooks
 * do not invalidate it, a page Refresh does.
 */

import { useQuery } from "@tanstack/react-query";
import { adminMessagesFiltersMeta } from "../utils/adminApi";

export const ADMIN_MESSAGES_FILTERS_META_QUERY_KEY = ["admin", "messages", "filters-meta"];

const EMPTY_META = Object.freeze({
  statuses: [],
  origins: [],
  origin_details: [],
  recipient_kinds: [],
  channels: [],
  email_template_variants: [],
  automations: [],
  buckets: [],
});

export const useAdminMessagesFiltersMeta = ({ enabled = true } = {}) => {
  const query = useQuery({
    queryKey: ADMIN_MESSAGES_FILTERS_META_QUERY_KEY,
    queryFn: () => adminMessagesFiltersMeta(),
    enabled,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
  return { ...query, meta: query.data || EMPTY_META };
};

export default useAdminMessagesFiltersMeta;
